import * as API from "middleware/api";

// eslint-disable-next-line import/prefer-default-export
export const listConfiguration = () => API.executeAnonymous("/configuration.listConfiguration");
